module.exports = __webpack_public_path__ + "builder-icon-homee-1yAI1li.jpg";